export const getUrlSearchParameter = (searchParameter: string) =>
  new URLSearchParams(window.location.search)?.get(searchParameter)
